import biRequest from "./index";


const proxyHead = ''


// 获取 指数
// 返回值
// [
//   {
//     "PriceTime": "/Date(1675958400000)/",
//     "Price": "100",
//     "SKUName": "玉米",
//     "ProductName": null,
//     "CategoryName": null,
//     "ChangePrice": 0
//   }
// ]
export function getZhishu() {
  const url = proxyHead + '/api/popularize/public/commodityPrice/commRiseOrFall/getCommoditiesTodayPrice'
  return biRequest({url,method: 'post'});
}

/**
 *	@description 获取首页 价格涨跌 数据
 * 	@returns
 */
export function getPriceInfo() {
  const url = '/api/popularize/public/commodityPrice/commRiseOrFall/commoditiesRiseAndFall'
  return biRequest({url , method: 'get'});
}

/**
 *	@description 获取首页 价格涨跌 数据
    @params {Object} 
 * 	@returns
 */
export function getEcnomony(params){
  const url = proxyHead + "/Home/GetMacroscopicData?NewsCategoryID=895"
  return biRequest({ url, method: 'get', params});
}

// 百川盈孚视点
export function getViewpoint(data) {
  const url = '/api/popularize/public/commodityPrice/commRiseOrFall/getBaiInfoViewpoint'
  return biRequest({ url, method: 'post', data});
}

// 百川市场动态
export function getMarketDynamic(params) {
  const url = proxyHead + "/Home/GetMarketDynamicsData"
  return biRequest({ url, method: 'get', params});
}

// 百川盈孚日评
export function getDailyCommit(params) {
  const url = proxyHead + "/Home/GetDailyReviewData"
  return biRequest({ url, method: 'get', params});
}

// 1 周报，2 月报，4 年报，3 半年报

// 周报
export function getReportWeek(data) {
  const url = '/api/popularize/public/commodityPrice/commRiseOrFall/getWebsiteReport'
  const TYPE = 1
  return new Promise(async (resolve, reject) => {
    try {
      const res = await biRequest({
        url,
        method: 'post',
        data: {
          ...data,
          columnIds: [TYPE]
        }
      })
      if (res.code === 200) {
        const resData = res.data
        const list = resData[TYPE] || []
        resolve({
          ...res,
          data: list
        })
      } else {
        reject(res)
      }
    } catch (error) {
      reject(error)
    }
  })
}

// 月报
export function getReportMonth(data) {
  const url = '/api/popularize/public/commodityPrice/commRiseOrFall/getWebsiteReport'
  const TYPE  = 2
  return new Promise(async (resolve,reject)=>{
    try {
      const res = await biRequest({
        url,
        method: 'post',
        data: {
          ...data,
          columnIds: [TYPE]
        }
      })
      if(res.code === 200){
        const resData = res.data
        const list =  resData[TYPE] || []
        resolve({
          ...res,
          data: list
        })
      } else {
        reject(res)
      }
    } catch (error) {
      reject(error)
    }
  })
}
  

// 年报
export function getReportYear(data) {
  const url = '/api/popularize/public/commodityPrice/commRiseOrFall/getWebsiteReport'
  const TYPE = 4
  return new Promise(async (resolve, reject) => {
    try {
      const res = await biRequest({
        url,
        method: 'post',
        data: {
          ...data,
          columnIds: [TYPE]
        }
      })
      if (res.code === 200) {
        const resData = res.data
        const list = resData[TYPE] || []
        resolve({
          ...res,
          data: list
        })
      } else {
        reject(res)
      }
    } catch (error) {
      reject(error)
    }
  })
}

// 获取类别指定数据
export function getClassInfo(params){
  const url = proxyHead + "/home/getnews"
  return biRequest({ url, method: 'get', params });
}
export function getClassInfo_all(params){
  const url = '/api/popularize/public/commodityPrice/commRiseOrFall/getNewsByNewIds'
  return biRequest({ url, method: 'get', params });
}
// 获取类别指定数据
export function getClassInfo_1(params) {
  const url = '/api/popularize/public/commodityPrice/commRiseOrFall/getNewsByNewIds'
  return biRequest({ url, method: 'get', params });
}
// 获取类别指定数据
export function getClassInfo_2(params) {
  const url = '/api/popularize/public/commodityPrice/commRiseOrFall/getNewsByNewIds'
  return biRequest({ url, method: 'get', params });
}
// 获取类别指定数据
export function getClassInfo_3(params) {
  const url = '/api/popularize/public/commodityPrice/commRiseOrFall/getNewsByNewIds'
  return biRequest({ url, method: 'get', params });
}

// 获取异动数据
export function getYiDong(params) {
  const url = '/api/popularize/public/commodityPrice/commRiseOrFall/getAttentionChangeList'
  return biRequest({ url, method: 'get', params });
}

